const STATUS_COLORS: Record<string, string> = {
  online: 'bg-green-500',
  busy: 'bg-yellow-500',
  offline: 'bg-zinc-600',
};

interface StatusIndicatorProps {
  status?: string;
  size?: 'sm' | 'md';
}

export function StatusIndicator({ status = 'offline', size = 'sm' }: StatusIndicatorProps) {
  const colorClass = STATUS_COLORS[status] || STATUS_COLORS.offline;
  const sizeClass = size === 'sm' ? 'w-2.5 h-2.5' : 'w-3 h-3';

  return (
    <span
      className={`inline-block ${sizeClass} ${colorClass} rounded-full ring-2 ring-void`}
      title={status.charAt(0).toUpperCase() + status.slice(1)}
    />
  );
}
